module.exports = __webpack_public_path__ + "img/sld_ch_3_t1_green.398d4cfb.svg";